// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module
import computeStackTrace from 'ui-forms-embed-components-reporting/reporting/internal/computeStackTrace';
import getUUID from 'ui-forms-embed-components-reporting/reporting/utils/getUUID';
const buildErrorPayload = (level, error, {
  env = 'prod',
  url = '',
  query = '',
  version = '',
  hublet = '',
  tags = {},
  user = {},
  extra = {}
}) => {
  const timestampMS = Date.now() / 1000;
  const stacktrace = computeStackTrace(error);
  return {
    environment: env,
    tags: Object.assign({
      region: hublet
    }, tags),
    logger: 'javascript',
    platform: 'javascript',
    request: {
      headers: {
        'User-Agent': navigator.userAgent
      },
      url: url || window.location.href,
      queryString: query.replace(/^\?/, '')
    },
    event_id: getUUID().replace(/-/g, ''),
    transaction: stacktrace.stack ? stacktrace.stack[0].filename : stacktrace.filename,
    level,
    exception: {
      values: [{
        mechanism: {
          handled: true,
          type: 'generic'
        },
        type: stacktrace.name,
        value: stacktrace.message,
        stacktrace: {
          frames: stacktrace.stack ? stacktrace.stack.reverse() : []
        }
      }]
    },
    timestamp: timestampMS,
    version,
    user,
    extra
  };
};
export default buildErrorPayload;